import {getTutorialStepConfig} from '../constants';
import type {FavoriteAddressTutorialStep} from '../types';

export function getTargetSelector(step: FavoriteAddressTutorialStep): string {
	return getTutorialStepConfig(step)?.targetSelector ?? '';
}
